import { createFileRoute } from '@tanstack/react-router'
import { ManualKeyPage } from '@/features/auth'

/** `/login/setup-authenticator/manual-key` — Step 2 alternative: enter key manually. */
export const Route = createFileRoute('/login/setup-authenticator/manual-key')({
  component: ManualKeyPage,
})
